module.exports = __webpack_public_path__ + "images/security_badge.webp";